/**
 * Place des Arts — liste de langues du sélecteur géo.
 *
 * ⛔ CE MODULE NE SOUMET RIEN LUI-MÊME. Il pilote le `<select>` natif d'Horizon, resté
 * monté dans `.pda-geo-dd__lang-native`, et le laisse émettre son `change` : c'est
 * `localization-form-component.changeLanguage()` qui écrit `languageInput.value` puis
 * appelle `form.submit()`. Le POST, le `return_to` et la gestion d'erreur restent
 * intégralement natifs.
 *
 * Pourquoi passer par le `<select>` et pas par un binding direct — MESURÉ, pas supposé :
 * `changeLanguage()` fait `event.target instanceof HTMLSelectElement ? event.target.value
 * : null` (assets/localization.js:109) et ne fait RIEN si la valeur est nulle. Un
 * `on:click` posé sur nos boutons serait donc un no-op SILENCIEUX.
 *
 * ⛔ LE MARQUEUR EST LA PREMIÈRE CHOSE QU'ON POSE, ET C'EST VOLONTAIRE. Le HTML par défaut
 * montre le `<select>` natif et masque la liste PDA ; c'est `data-pda-geo-lang` qui
 * inverse les deux. Donc si ce fichier n'est pas servi (asset 404, erreur d'évaluation),
 * la langue reste changeable par le menu système au lieu de laisser cinq boutons morts.
 * La panne DÉGRADE, elle ne casse pas.
 *
 * ⛔ AUCUN `preventDefault()` ICI, ET LE GARDE EST EN TÊTE. Le 20/08, un module de ce
 * sélecteur a annulé TOUS les clics du site en appelant `closest()` sur un attribut posé
 * haut dans l'arbre puis en préemptant l'événement : plus aucun lien ne naviguait. On sort
 * donc immédiatement si le clic ne vient pas d'un bouton de langue, et le sélecteur est
 * ancré sur `button[...]` — pas sur l'attribut nu, qui matcherait n'importe quel conteneur
 * qu'on déciderait un jour de marquer (`pda-metric.js` prend la même ceinture).
 */

document.documentElement.dataset.pdaGeoLang = '1';

document.addEventListener('click', (event) => {
  // Garde en TÊTE : tout ce qui n'est pas un bouton de langue ressort intact.
  const cible = event.target;
  if (!(cible instanceof Element)) return;

  const bouton = cible.closest('button[data-pda-lang]');
  if (!bouton) return;

  const racine = bouton.closest('[data-pda-geo]');
  const select = racine?.querySelector('.pda-geo-dd__lang-native select[name="language_code"]');

  // ⛔ Échouer FORT : sans le `<select>` natif il n'y a PAS de chemin de repli — ce module
  // ne reconstruit pas le POST du formulaire natif. Un échec muet laisserait un bouton qui
  // ne fait rien.
  if (!select) {
    console.error('[pda-geo] <select name="language_code"> introuvable — langue non changée.');
    return;
  }
  // Le composant natif doit être monté : c'est lui qui écoute `change`. S'il ne l'est pas
  // (localization.js non chargé, upgrade empêché), l'événement partirait dans le vide.
  if (!customElements.get('localization-form-component') || !select.closest('localization-form-component')) {
    console.error('[pda-geo] localization-form-component non monté — langue non changée.');
    return;
  }

  const code = bouton.dataset.pdaLang;
  // Même langue : ne pas relancer une navigation complète pour un choix sans effet.
  if (!code || select.value === code) return;

  select.value = code;
  select.dispatchEvent(new Event('change', { bubbles: true }));
});

/**
 * Échap referme le sélecteur et rend le focus à son déclencheur.
 * ⚠️ Le thème n'a de fermeture générique que sur les pages catalogue (effet de bord de
 * `pda-facets.js`) : sur la home ou une page contenu, le panneau restait ouvert sans
 * aucune sortie au clavier. Le composant doit posséder sa propre fermeture.
 */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const cible = event.target;
  if (!(cible instanceof Element)) return;

  const racine = cible.closest('details[data-pda-geo][open]');
  if (!racine) return;

  racine.open = false;
  racine.querySelector('summary')?.focus();
});
